import React, { useState } from 'react';
import './Home.css'
import Navbar from '../components/navbar';
import Hero from '../sections/hero';
import About from '../sections/about';
import ThirdSec from '../sections/thirdsec';
import LastSec from '../sections/lastsec';
import Footer from '../components/footer';
import Preloader from '../components/preloader';

const Home = () => {

const [loading,setLoading] = useState(true);
const [autoPlayMusic,setAutoPlayMusic] = useState(false);

const handleEnterSite = () => {
setLoading(false);
setAutoPlayMusic(true);
};

return (
<>
<div className="responsive-error-page">
<h1>Oops!</h1>
<p>This website is not available on small screens.</p>
<span>Please open it on desktop or laptop.</span>
</div>

<div className="desktop-site">
{loading ? (
<Preloader onEnter={handleEnterSite}/>
) : (
<>
<Navbar autoPlayMusic={autoPlayMusic}/>
<Hero/>
<About/>
<ThirdSec/>
<LastSec/>
<Footer/>
</>
)}
</div>

</>
);

}

export default Home;